import { render, staticRenderFns } from "./BreakdownCharts.vue?vue&type=template&id=77aed3b2&scoped=true&"
import script from "./BreakdownCharts.vue?vue&type=script&lang=js&"
export * from "./BreakdownCharts.vue?vue&type=script&lang=js&"
import style0 from "./BreakdownCharts.vue?vue&type=style&index=0&id=77aed3b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aed3b2",
  null
  
)

export default component.exports